import {useActions, useGetters, useMutators, useState} from './_default';
import moment from "moment/moment";
export default {
    namespaced: true,
    state: {
        ...useState(),
        visible: false,
        expanded: true,
        hiddenObjectId: null,
    },
    getters: {
        ...useGetters(),
        visible: state => state.visible,
        expanded: state => state.expanded,
    },
    mutations: {
        ...useMutators(),
        visible(state, status) {
            state.visible = status;
        },

        expanded(state, status) {
            state.expanded = status;
        },

        'fuel-graph': (state, data) => {
            state.graphError = data?.error;
            if (!data.data) {
                state.graphData = null;
                return;
            }
            state.graphData = (Array.isArray(data.data) ? data.data: Object.values(data.data)).map((sensor) => {
                sensor.values = Object.values(sensor.values).map(({ t, v }) => {
                    const x = moment.unix(t).toDate().getTime();
                    return { x, y: v }
                });
                return sensor;
            });
        },

        show(state) {
            if (!state.selected) {
                state.selected = state.hiddenObjectId;
            }
            state.hiddenObjectId = null;
        },

        hide(state) {
            state.hiddenObjectId = state.selected;
            state.selected = null;
        }
    },
    actions: {
        ...useActions(),
        setFirstDevice({ rootGetters, commit }) {
            const list = rootGetters['object/list'];
            if (!list.length) return;
            commit('select', list.reduce((max, current) => {
                const c1 = current?.sensors?.length || 0;
                const c2 = max?.sensors?.length|| 0;
                return c1 > c2 ? current : max;
            }, list[0]).id);
        }
    },
}
